import React, { useRef, useEffect, useState } from 'react';
import Box from '../../m/common/Box';
import ModuleBox from './ModuleBox';
import { toPercentTime } from '../../../common/utils/convertUtil';
import { getClickLinkParams } from '../../../common/utils/appLinkUtil';

export default function SliderItem (props) {
  const [appLink, setAppLink] = useState(props.app_link);

  const ref = useRef(null);
  const childRef = useRef(null);
  const onHover = (e) => { };

  const onHoverLeave = (e) => { };

  useEffect(() => {
    setAppLink(props.app_link);
  }, [props.app_link]);

  function moveTouchPause (val) {
    props.moveTouchPause(val);
  }

  switch (props.type) {
    case 'poster':
      break;
    case 'event':
      break;
    case 'modulebox':
      break;
    case 'schedule':
      break;
    case 'eventtopbox':
      break;
    default:
      break;
  }

  if (props.type === 'modulebox') {
    return (
      <li
        key={props.index}
        className={`mvsl_inner${props.index === props.currentIndex ? ' current' : ''
          }`}
        aria-hidden={props.index === props.currentIndex ? 'false' : 'true'}
      >
        <a
          href={getClickLinkParams(props.home_link,'div=main_top_img')}
          className='mvsl_link_home'
          tabIndex={props.index === props.currentIndex ? '0' : '-1'}
          title='바로가기'
        >
          <i className='ir'>{`${props.main_title}, ${props.home_name}`}</i>
        </a>

        <ModuleBox {...props} moveTouchPause={moveTouchPause} />
      </li>
    );
  } else if (props.type === 'eventtopbox') {
    // img={props.data.img || props.data.pc_img_url || props.data.pgm_img_url}
    // //console.log('find data : ' + props.img_url);
    if (props.m_link_url !== null) {
      let linkUrl;
      if (props.link_url) {
        const temp = new URL(props.m_link_url);
        temp.searchParams.set('div', 'event_top');
        linkUrl = temp.toString();
      }
      return (
        <li className={`event_topswipe_inner${props.index === props.currentIndex ? ' current' : ''}`}>
          <a
            href={`${linkUrl}`}
            target={props.m_link_new_yn === 'Y' ? '_blank' : ''}
            className='event_topswipe_link'
          >
            <img src={props.m_img_url} className='event_topswipe_image' />
          </a>
        </li>
      );
    } else {
      return (
        <li className={`event_topswipe_inner${props.index === props.currentIndex ? ' current' : ''}`}>
          <img src={props.m_img_url} className='event_topswipe_image' />
        </li>
      );
    }
  } else {
    const listClassName =
      props.type === 'event' || typeof props.type === 'number'
        ? 'module_thumb_list_cont'
        : `module_${props.type}_list_cont`;

    let currentValue;
    if (props.data.current !== undefined && props.data.current) {
      currentValue = true;
    } else {
      currentValue = !!(
        props.index !== undefined && props.index === props.currentIndex
      );
    }

    const label = [];
    let linkUrl = props.data.link || props.data.link_url || props.data.homepage_url || props.data.pc_img_link;

    if (props.data.channel_payment === 'N') label.push({ type: 'free' });
    if (parseInt(props.data.target_age) >= 19) label.push({ type: '19' });
    if (props.data.channelid === 'S17' || props.data.channelid === 'S18') { label.push({ type: 'bora' }); }

    if (props.data.channelid === 'S01' && props.data.desc && props.data.desc === 'SBS 카타르 2022') {
      label.push({ type: 'multiaudio' });
      linkUrl = './live/' + props.data.channelid + '?mode=multiaudio';
    }
    const percent = toPercentTime(props.data.starttime, props.data.endtime);
    const progress = {
      percent: percent,
      status: `${props.data.starttime}~${props.data.endtime} ${percent} 방송 중..`
    };

    return (
      <li
        key={props.data.ord_no}
        ref={ref}
        onMouseLeave={(e) => onHoverLeave(e)}
        onMouseEnter={(e) => onHover(e)}
        className={listClassName}
      >
        <Box
          link_new_yn={props.data.link_new_yn}
          relateId={props.relateId}
          relateTitle={props.relateTitle}
          relateTitleViewYn={props.relateTitleViewYn}
          relateType={props.relateType}
          content_date={props.data.content_date}
          content_num={props.data.content_num}
          content={props.data.content}
          srs_div={props.data.srs_div}
          srs_no={props.data.srs_no}
          srs_dtl_no={props.data.srs_dtl_no}
          view={props.view}
          type={props.type}
          current={currentValue}
          label={label}
          time={props.data.time || ''}
          play={props.data.play || false}
          img={props.data.m_img_url || props.data.img}
          progress={progress}
          imageQuality={props.imageQuality || 50}
          link={linkUrl}
          title={props.data.pc_title}
          info={{
            title: props.data.program_title || props.data.title,
            desc:
              props.data.desc ||
              props.data.pc_title ||
              (props.data.starttime != null
                ? `${props.data.starttime} ~ ${props.data.endtime}`
                : ''),
            media_id: appLink,
            pgm_title: props.data.pgm_title,
            pgm_tms_title: props.data.pgm_tms_title,
            pgm_nm: props.data.pgm_nm,
          }} // TODO childmild ======>
          targetage={props.data.targetage}
          mainContentsType={props.mainContentsType}
          data={props.data}
          bottom_type={props.bottom_type}
          clickParams={props.clickParams}
          m_view_yn={props.data.m_view_yn}
          app_link={appLink}
          />
      </li>
    );
  }
}
